import { dia, util } from '@joint/plus';
import { UpdateFlags } from '../utils/flags';

// Vue simplifiée pour l'élément Navigator

export const NavigatorElementView = dia.ElementView.extend({
  body: null,
  markup: util.svg /* xml */ `<path @selector="body" opacity="0.4" />`,
  initFlag: [UpdateFlags.Render, UpdateFlags.Update, UpdateFlags.Transform],
  presentationAttributes: {
    position: [UpdateFlags.Transform],
    angle: [UpdateFlags.Transform],
    size: [UpdateFlags.Update], // forme
  },
  confirmUpdate: function (flags) {
    if (this.hasFlag(flags, UpdateFlags.Render)) this.render();
    if (this.hasFlag(flags, UpdateFlags.Update)) this.update();
    if (this.hasFlag(flags, UpdateFlags.Transform)) this.updateTransformation();
  },
  render: function () {
    const doc = util.parseDOMJSON(this.markup);
    this.body = doc.selectors.body;
    this.body.classList.add(this.model.get('group'));
    this.el.appendChild(doc.fragment);
  },
  update: function () {
    const { model, body } = this;
    const { width, height } = model.size();
    const d = `M 0 0 H ${width} V ${height} H 0 Z`;
    body.setAttribute('d', d);
  },
});
